import { boolean, number, object, string } from 'yup'

export const validationSchema = object().shape({
  active: boolean().required(),
  include_original_checkers: boolean().required(),
  code: string().trim().required(),
  name: string().trim().required(),
  organization_id: number().typeError().required(),
  // policy_conference_exception_trees: array().of(object().shape({})),
  policy_conference_id: number().typeError().notRequired(),
  policy_conference_rule_id: number().typeError().notRequired(),
  policy_receipt_rule_id: number().typeError().notRequired()
})
